import React from 'react'
import { useParams } from 'react-router-dom';
import Tags from './Tags';


function TagsPage() {
  var params = useParams();
  var { groupId } = params;
  return (
    <div className="main-content">
      <Tags groupId={groupId} searchIcon={true} />
    </div>
  )
}

export default TagsPage